const translationContext = "clients.form.enum";
export default [
  { value: "CHEQUE", key: `${translationContext}.cheque` },
  { value: "TRANSFER", key: `${translationContext}.transfer` },
  {
    value: "PREAUTHORIZED DEBIT",
    key: `${translationContext}.preauthorized_debit`,
  },
];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/paymentTypes.js